/* import __COLOCATED_TEMPLATE__ from './call-quality-health-card.hbs'; */
/* RESPONSIBLE TEAM: team-phone */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type { MetricHealth, QualityLevel } from 'embercom/utils/call-quality-monitor';

interface Signature {
  Args: {
    metricHealth: MetricHealth;
    overallQuality: QualityLevel;
    onViewDetails: () => void;
    onClose: () => void;
  };
}

export default class CallQualityHealthCard extends Component<Signature> {
  @service declare intl: IntlService;

  get overallTitle(): string {
    if (this.args.overallQuality === 'good') {
      return this.intl.t('calling.modal.quality.connection-good');
    }
    return this.intl.t('calling.modal.quality.connection-unstable');
  }

  get overallDescription(): string {
    if (this.args.overallQuality === 'good') {
      return this.intl.t('calling.modal.quality.connection-good-description');
    }
    if (this.args.overallQuality === 'poor') {
      return this.intl.t('calling.modal.quality.connection-poor-description');
    }
    return this.intl.t('calling.modal.quality.connection-unstable-description');
  }

  get isGoodQuality(): boolean {
    return this.args.overallQuality === 'good';
  }

  get networkLabel(): string {
    return this.qualityLabel(this.args.metricHealth.network);
  }

  get microphoneLabel(): string {
    return this.qualityLabel(this.args.metricHealth.microphone);
  }

  get speakerLabel(): string {
    return this.qualityLabel(this.args.metricHealth.speaker);
  }

  private qualityLabel(level: QualityLevel): string {
    switch (level) {
      case 'good':
        return this.intl.t('calling.modal.quality.good');
      case 'fair':
        return this.intl.t('calling.modal.quality.fair');
      case 'muted':
        return this.intl.t('calling.modal.quality.muted');
      case 'no_input':
        return this.intl.t('calling.modal.quality.no-input');
      case 'no_audio':
        return this.intl.t('calling.modal.quality.no-audio');
      default:
        return this.intl.t('calling.modal.quality.poor');
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Calling::CallQualityHealthCard': typeof CallQualityHealthCard;
    'inbox2/calling/call-quality-health-card': typeof CallQualityHealthCard;
  }
}
